module.exports = __webpack_public_path__ + "img/kh9.1094020d.png";